import Button from '@material-ui/core/Button'
import { makeStyles } from '@material-ui/core/styles'
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos'
import React from 'react'

import { widthXS } from '../theme'

const useStyles = makeStyles((theme) => ({
  button: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontFamily: theme.palette.primary.fontW1G,
    color: theme.palette.primary.Seagull,
    padding: '0 5px',
    [theme.breakpoints.down(widthXS)]: {
      width: '100%',
      margin: '0 15px 0 0',
    },
    textTransform: 'initial',
    textDecoration: 'underline',
    textAlign: 'center',
    fontSize: '0.8rem',
    height: 30,
    '&:hover': {
      textDecoration: 'none',
      border: 'none',
      backgroundColor: theme.palette.primary.White,
    },
  },
  buttonIcon: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
    color: theme.palette.primary.Seagull,
    height: 16,
    width: 16,
    backgroundSize: '100% 100%',
  },
}))

export const BackButton = ({ children, props, onClick }) => {
  const classes = useStyles()

  return (
    <Button
      className={classes.button}
      startIcon={<ArrowBackIosIcon className={classes.buttonIcon} />}
      {...props}
      onClick={onClick}
    >
      {children}
    </Button>
  )
}
